// extracted by mini-css-extract-plugin
export default {"root_image_inner":"typeForm_root_image_inner__n6Rd0"};